import { Component, OnInit } from '@angular/core';
import { getRegisterFile, RegisterModel } from 'src/app/shared/models/register.model';
import { Base64ToBlobService } from 'src/app/shared/services/base64-to-blob/base64-to-blob.service';
import { FormBuilder, FormGroup, FormControl, Validators, RequiredValidator } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as Config from 'src/app/config/app.constant';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { Router } from '@angular/router';
import { UploadFile } from 'ng-zorro-antd';
import { FileModelUser } from 'src/app/shared/models/upload.model';
import { RegistersModel } from 'src/app/shared/models/registersModel.model';
import { FileListModel } from 'src/app/shared/models/registersModel.model';
import * as moment from 'moment';
import { HospModel } from 'src/app/shared/models/hospital.model';
import { ModalService } from 'src/app/shared/services/utils/modal.service';
import { RegisterService } from '../service/register.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  form: FormGroup;
  currentLang: string;
  textWarnnig: string;
  titelWarnnig: string;
  fileList: UploadFile[] = [];
  fileModel: FileModelUser[] = [];
  isSameIdCard = false;
  isSameUsername = false;
  openModal = false;
  isWarning = false;
  registerModel: RegistersModel;
  fileListRegister: FileListModel[];
  nameFile: string;
  hospList: HospModel[];
  selectedHosp: boolean = false;

  constructor(
    public base64ToBlobService: Base64ToBlobService,
    private fb: FormBuilder,
    public translate: TranslateService,
    private util: UtilsService,
    private router: Router,
    private modalService: ModalService,
    private service: RegisterService,
  ) {
    this.currentLang = localStorage.getItem(Config.CURRENT_LANGUAGES) ? localStorage.getItem(Config.CURRENT_LANGUAGES) : 'th';
    translate.setDefaultLang(this.currentLang);
    this.translate.use(this.currentLang);
  }

  ngOnInit() {
    this.getHospital();
    this.buildForm();
  }

  buildForm(): void {
    this.form = this.fb.group({
      idCard: new FormControl(''),
      titleName: new FormControl(''),
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      username: new FormControl(''),
      hospitalCode: new FormControl(''),
      email: new FormControl(''),
      fileName: new FormControl(''),
      confirm: new FormControl(false, [Validators.required])
    });
  }

  setValidateRequire(): void {
    this.form.get('idCard')!.setValidators([Validators.required]);
    this.form.controls.idCard.updateValueAndValidity();
    this.form.get('titleName')!.setValidators([Validators.required]);
    this.form.controls.titleName.updateValueAndValidity();
    this.form.get('firstName')!.setValidators([Validators.required]);
    this.form.controls.firstName.updateValueAndValidity();
    this.form.get('lastName')!.setValidators([Validators.required]);
    this.form.controls.lastName.updateValueAndValidity();
    this.form.get('username')!.setValidators([Validators.required, Validators.minLength(5)]);
    this.form.controls.username.updateValueAndValidity();
    this.form.get('hospitalCode')!.setValidators([Validators.required]);
    this.form.controls.hospitalCode.updateValueAndValidity();
    this.form.get('email')!.setValidators([Validators.required, Validators.email]);
    this.form.controls.email.updateValueAndValidity();
  }

  prepareData(): RegistersModel {
    const host = new HospModel();
    this.hospList.forEach(element => {
      if (element.hospCode === this.form.controls.hospitalCode.value) {
        host.hospCode = element.hospCode;
        if(element.hospName.substring(0, 9) != "โรงพยาบาล"){
          host.hospName = "โรงพยาบาล" + element.hospName;
        }
      }
    });
    let param = new RegistersModel;
    param.idCard = this.form.value.idCard;
    param.titleName = this.form.value.titleName;
    param.firstName = this.form.value.firstName;
    param.lastName = this.form.value.lastName;
    param.username = this.form.value.username;
    param.hospitalCode = host.hospCode;
    param.hospitalName = host.hospName;
    param.email = this.form.value.email;
    param.fileList = this.fileListRegister;
    param.createBy = "";
    return param;
  }

  register(): void {
    if (this.form.controls.confirm.value === true) {
      for (const key in this.form.controls) {
        this.setValidateRequire();
        this.form.controls[key].markAsDirty();
        this.form.controls[key].updateValueAndValidity();
      }
      if (this.form.valid) {
        let param = this.prepareData();
        this.service.insertUsertemp(param).subscribe((res: any) => {
          this.modalService.success('ยืนยันข้อมูลสำเร็จ', '');
          console.log(param);
          console.log(res);
          this.onReset();
        }, err => {
          console.log('error save user --> ', err);
          if (err.error.resultData.idCard == true) {
            this.isSameIdCard = true;
            this.form.get('idCard')!.setValidators([Validators.required, this.invalidIdCard]);
            this.form.controls.idCard.updateValueAndValidity();
          } else {
            this.isSameIdCard = false;
          }
          if (err.error.resultData.username == true) {
            this.isSameUsername = true;
            this.form.get('username')!.setValidators([Validators.required, this.invalidUsername]);
            this.form.controls.username.updateValueAndValidity();
          } else {
            this.isSameUsername = false;
          }
        })
      }
    }
  }

  getHospital(): void {
    const result = new Array<HospModel>();
    this.service.getHospital().subscribe((res: any) => {
      res.value.forEach(element => {
        const tem = new HospModel();
        tem.hospCode = element.hospital.code;
        tem.hospName = element.hospital.name;
        tem.label = element.hospital.code + ' - ' + element.hospital.name;
        result.push(tem);
      });
      this.hospList = [...result];
    });
  }

  downloadDoc(): void {
    const data: RegisterModel = getRegisterFile();
    this.base64ToBlobService.openBase64(data.registerFile, 'pdf');
  }

  uploadDoc(): void {
    this.openModal = true;
  }

  popupAgreement(confirm: boolean): void {
    if (confirm) {
      this.titelWarnnig = 'ข้อตกลงและเงื่อนไข';
      this.textWarnnig = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx';
      this.isWarning = true;
    }
  }

  numberOnly(event: any): boolean {
    return this.util.numberOnly(event);
  }

  setIdCard(): void {
    this.form.get('idCard')!.setValidators([Validators.minLength(13)]);
    this.form.controls.idCard.updateValueAndValidity();
  }

  setUsername(): void {
    this.form.get('username')!.setValidators([Validators.minLength(5)]);
    this.form.controls.username.updateValueAndValidity();
  }

  invalidIdCard = (control: FormControl): { [s: string]: boolean } => {
    if (this.isSameIdCard) {
      return { idCardIsSame: true, error: true };
    } else if (control.value) {
      if (control.value.length > 1) {
        if (control.value.length < 13) {
          return { minlength: true, error: true };
        }
      }
    }
  }

  invalidUsername = (control: FormControl): { [s: string]: boolean } => {
    if (this.isSameUsername) {
      return { usernameIsSame: true, error: true };
    } else if (control.value) {
      if (control.value.length > 1) {
        if (control.value.length < 5) {
          return { minlength: true, error: true };
        }
      }
    }
  }

  previousPage(): void {
    this.router.navigate(['/login']);
  }

  closeModal(data: FileModelUser[]): void {
    this.fileList = [];
    let fileName = '';
    this.fileModel = data;
    this.fileListRegister = [];
    let fileData = '';
    const currentDate: string = moment(new Date).format('YYYYMMDD_HH-mm-ss');
    data.forEach(element => {
      this.fileList.push(element.fileData);
      fileName += element.fileName + '   ';
      fileData += element.file;
    });
    for (let i = 1; i <= data.length; i++) {
      var formattedNumber = ("000" + i).slice(-3);
      this.nameFile = currentDate + "_" + this.prepareData().username + "_" + (formattedNumber);
      this.fileListRegister.push({ fileName: this.nameFile, file: fileData });
    }
    this.form.get('fileName').setValue(fileName);
    this.openModal = false;
  }

  closeWarning(): void {
    this.isWarning = false;
  }

  onReset(): void {
    this.resetRegister();
  }

  resetRegister(): void {
    this.form.get('idCard')!.reset();
    this.form.get('titleName')!.reset();
    this.form.get('firstName')!.reset();
    this.form.get('lastName')!.reset();
    this.form.get('username')!.reset();
    this.form.get('fileName')!.reset();
    this.form.get('hospitalCode')!.reset();
    this.form.get('email')!.reset();
    this.form.get('confirm').setValue(false);
    this.fileListRegister = [];
  }

}
